


































import Vue from 'vue'
import { Component, Prop, Emit, Watch } from 'vue-property-decorator'

@Component({
})
export default class AppSearch extends Vue {
  @Prop({ type: [Number, String], default: 230 }) readonly width!: number | string
  @Prop(String) readonly value!: string
  @Prop({ default: 'Search...' }) readonly placeholder!: string
  @Prop({ default: false }) readonly noInput!: boolean

  model = ''

  outlined = false

  @Watch('value')
  onValueChanged (val: string) {
    this.model = val
  }

  mounted () {
    this.model = this.value
  }

  @Emit('input')
  valueChangedHandler (val: string) {
    this.model = val
    return val
  }

  @Emit()
  submit () {}
}
